import styled from 'foundations-theming/utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useState } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/components/View';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { FilterIcon, RemoveIcon } from 'foundations-assets';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { PublicCatalogFilters } from '../publicCatalogConstants';
import { ExpandableSection } from 'foundations-components/transitional/components/ExpandableSection';
import PublicCatalogAppliedFilters from './PublicCatalogAppliedFilters';
import { Box } from 'foundations-components/transitional/components/Box';
import usageTracker from '../../../utils/usageTracker';
import { useClearAllFilters } from '../publicCatalogFiltersHooks';
import I18n from 'I18n';
import PublicCatalogMobileFilterOption from './PublicCatalogMobileFilterOption';
import PublicCatalogMobileResultsDisplay from './PublicCatalogMobileResultsDisplay';
import { useGetCatalogResultsFromUrlFilters } from '../publicCatalogResultsHooks';
import { PAGE_SIZE } from './PublicCatalogResults';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const FiltersMenu = styled.div.withConfig({
  displayName: "PublicCatalogMobileFilters__FiltersMenu",
  componentId: "sc-9scopd-0"
})(({
  theme
}) => ({
  overflow: 'auto',
  backgroundColor: theme.color['fill-surface-default'],
  height: '100vh',
  width: '100vw',
  position: 'fixed',
  top: 0,
  left: 0,
  transition: 'transform 0.3s ease',
  transform: 'translateY(100vh)',
  zIndex: 99,
  '&.open': {
    transform: 'translateY(0)'
  }
}));
const PublicCatalogMobileFilters = () => {
  var _publicCatalogData$to;
  const {
    publicCatalogData
  } = useGetCatalogResultsFromUrlFilters({
    pageSize: PAGE_SIZE
  });
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const clearAllFilters = useClearAllFilters();
  const resultsCount = (_publicCatalogData$to = publicCatalogData === null || publicCatalogData === void 0 ? void 0 : publicCatalogData.total) !== null && _publicCatalogData$to !== void 0 ? _publicCatalogData$to : null;
  const handleCloseMenuClick = () => {
    setIsMenuOpen(false);
    usageTracker.track('interaction', {
      action: 'close-mobile-catalog-filters-menu'
    });
  };
  const handleApplyButtonClick = () => {
    usageTracker.track('interaction', {
      action: 'apply-mobile-catalog-filters'
    });
    setIsMenuOpen(false);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(View, {
      backgroundColor: "fill-surface-raised",
      marginBlockEnd: "200",
      paddingInline: "400",
      children: /*#__PURE__*/_jsx(Paragraph, {
        margin: "0",
        typography: "body-125",
        children: /*#__PURE__*/_jsxs(TFlex, {
          align: "center",
          justify: "between",
          children: [/*#__PURE__*/_jsx(Box, {
            shrink: 1,
            children: /*#__PURE__*/_jsx(Paragraph, {
              margin: "0",
              typography: "body-100",
              children: /*#__PURE__*/_jsx(PublicCatalogMobileResultsDisplay, {})
            })
          }), /*#__PURE__*/_jsx(Box, {
            shrink: 0,
            children: /*#__PURE__*/_jsx(Paragraph, {
              margin: "0",
              typography: "body-125",
              children: /*#__PURE__*/_jsxs(Button, {
                __color: "icon-core-subtle",
                onClick: () => setIsMenuOpen(true),
                paddingBlock: "200",
                paddingInline: "300",
                use: "unstyled",
                children: [/*#__PURE__*/_jsx(FormattedMessage, {
                  message: "academyPublic.catalogPage.filters.filtersMenuButton"
                }), /*#__PURE__*/_jsx(IconHolder, {
                  icon: FilterIcon,
                  margin: "0 !important",
                  size: "500"
                })]
              })
            })
          })]
        })
      })
    }), /*#__PURE__*/_jsxs(FiltersMenu, {
      "aria-hidden": !isMenuOpen,
      "aria-modal": "true",
      className: isMenuOpen ? 'open' : '',
      "data-test-id": "mobile-filters-menu",
      role: "dialog",
      children: [/*#__PURE__*/_jsxs(View, {
        insetBlockStart: "0",
        position: "sticky",
        zIndex: 1,
        children: [/*#__PURE__*/_jsx(View, {
          as: "header",
          backgroundColor: "do-not-use-obsidian",
          paddingBlock: "200",
          paddingInline: "500",
          children: /*#__PURE__*/_jsx(Paragraph, {
            color: "text-primary-default",
            margin: "0",
            typography: "body-125",
            children: /*#__PURE__*/_jsxs(TFlex, {
              align: "center",
              justify: "between",
              children: [/*#__PURE__*/_jsx(IconButton, {
                "aria-label": I18n.text('academyPublic.catalogPage.filters.closeMobileMenuButton'),
                onClick: handleCloseMenuClick,
                paddingBlock: "200",
                paddingInlineEnd: "500",
                paddingInlineStart: "0",
                use: "transparent",
                children: /*#__PURE__*/_jsx(RemoveIcon, {
                  color: "icon-interactive-on-fill-default",
                  size: "400"
                })
              }), /*#__PURE__*/_jsxs(TFlex, {
                align: "center",
                gap: 12,
                justify: "end",
                children: [/*#__PURE__*/_jsx(Button, {
                  __color: "text-interactive-on-fill",
                  onClick: clearAllFilters,
                  paddingBlock: "200",
                  paddingInline: "300",
                  responsive: false,
                  use: "unstyled",
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "academyPublic.catalogPage.filters.clearAllButton"
                  })
                }), /*#__PURE__*/_jsx(Button, {
                  onClick: handleApplyButtonClick,
                  responsive: false,
                  use: "primary-white",
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "academyPublic.catalogPage.filters.applyButton"
                  })
                })]
              })]
            })
          })
        }), /*#__PURE__*/_jsx(View, {
          backgroundColor: "do-not-use-pantera",
          "data-test-id": "mobile-filters-results",
          minBlockSize: "40px",
          paddingBlock: "200",
          paddingInline: "500",
          children: /*#__PURE__*/_jsxs(Paragraph, {
            color: "text-primary-default",
            margin: "0",
            children: [resultsCount === 0 && /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.catalogPage.filters.noResults"
            }), resultsCount !== null && resultsCount > 0 && /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.catalogPage.filters.simpleResultsDisplay",
              options: {
                count: resultsCount
              }
            })]
          })
        }), /*#__PURE__*/_jsx(View, {
          backgroundColor: "fill-surface-raised",
          borderBlockEndColor: "border-core-subtle",
          borderBlockEndStyle: "solid",
          borderBlockEndWidth: "100",
          paddingBlock: "200",
          paddingInline: "500",
          children: /*#__PURE__*/_jsx(Paragraph, {
            margin: "0",
            typography: "body-125",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.catalogPage.filters.filterBy"
            })
          })
        })]
      }), /*#__PURE__*/_jsx("div", {
        children: Object.entries(PublicCatalogFilters).map(([filterName, filterOptions]) => {
          return /*#__PURE__*/_jsx(ExpandableSection, {
            titleText: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `academyPublic.catalogPage.filters.${filterName}.displayText`
            }),
            children: filterOptions.map((option, index) => {
              return /*#__PURE__*/_jsx(PublicCatalogMobileFilterOption, {
                filterName: filterName,
                isLast: index === filterOptions.length - 1,
                option: option
              }, option);
            })
          }, filterName);
        })
      })]
    }), /*#__PURE__*/_jsx(PublicCatalogAppliedFilters, {})]
  });
};
export default PublicCatalogMobileFilters;